var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72727 0C7.52229 0 6.54545 0.976833 6.54545 2.18182V3.27273H4.36364V5.45455C4.36364 6.05704 4.85205 6.54545 5.45455 6.54545H14.1818C14.7843 6.54545 15.2727 6.05704 15.2727 5.45455V3.27273H13.0909V2.18182C13.0909 0.976833 12.1141 0 10.9091 0H8.72727ZM8.72727 3.27273C8.72727 2.67024 9.21569 2.18182 9.81818 2.18182C10.4207 2.18182 10.9091 2.67024 10.9091 3.27273C10.9091 3.87522 10.4207 4.36364 9.81818 4.36364C9.21569 4.36364 8.72727 3.87522 8.72727 3.27273Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.36364H3.27273V5.45455C3.27273 6.65953 4.24956 7.63636 5.45455 7.63636H14.1818C15.3868 7.63636 16.3636 6.65953 16.3636 5.45455V4.36364H19.6364V24H0V4.36364ZM4 9H7.65217V12.6522H4V9ZM8.17391 9H11.8261V12.6522H8.17391V9ZM16 9H12.3478V12.6522H16V9ZM4 13.1739H7.65217V16.8261H4V13.1739ZM11.8261 13.1739H8.17391V16.8261H11.8261V13.1739ZM12.3478 13.1739H16V16.8261H12.3478V13.1739ZM7.65217 17.3478H4V21H7.65217V17.3478ZM8.17391 17.3478H11.8261V21H8.17391V17.3478ZM16 17.3478H12.3478V21H16V17.3478Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentReport);
export default __webpack_public_path__ + "static/media/ExperimentReport.483c4899d20335ccb48f51e8a999d75a.svg";
export { ForwardRef as ReactComponent };